var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10.75C16.2475 10.75 16.5833 10.4142 16.5833 10C16.5833 9.58579 16.2475 9.25 15.8333 9.25V10.75ZM3.63633 9.46967C3.34343 9.76256 3.34343 10.2374 3.63633 10.5303L8.4093 15.3033C8.70219 15.5962 9.17706 15.5962 9.46996 15.3033C9.76285 15.0104 9.76285 14.5355 9.46996 14.2426L5.22732 10L9.46996 5.75736C9.76285 5.46447 9.76285 4.98959 9.46996 4.6967C9.17706 4.40381 8.70219 4.40381 8.4093 4.6967L3.63633 9.46967ZM15.8333 9.25H4.16666V10.75H15.8333V9.25Z",
    fill: "#366EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlue);
export default __webpack_public_path__ + "static/media/left-arrow-blue.94df0fec00d4619454b7f15bfa7bc4d9.svg";
export { ForwardRef as ReactComponent };